import { useEffect } from 'react';
import { useI18n } from '../i18n/useI18n';

export interface DuetResult {
  id: string;
  kind: 'accepted' | 'declined' | 'expired' | 'failed';
  partnerName: string;
  songTitle?: string;
}

interface Props {
  result: DuetResult;
  onDone: (id: string) => void;
}

const KIND_ICON: Record<DuetResult['kind'], string> = {
  accepted: '🎤',
  declined: '🙁',
  expired: '⏰',
  failed: '⚠️',
};

export default function DuetResultToast({ result, onDone }: Props) {
  const { t } = useI18n();

  useEffect(() => {
    const timer = setTimeout(() => onDone(result.id), 5000);
    return () => clearTimeout(timer);
  }, [result.id, onDone]);

  return (
    <div className={`duet-toast duet-toast--result duet-toast--${result.kind}`} role="status">
      <div className="duet-toast__content">
        <span className="duet-toast__icon" aria-hidden="true">
          {KIND_ICON[result.kind]}
        </span>
        <div className="duet-toast__info">
          <div className="duet-toast__title">
            {t(`duet.result.${result.kind}`, { name: result.partnerName })}
          </div>
          {result.songTitle && <div className="duet-toast__song">{result.songTitle}</div>}
        </div>
      </div>
    </div>
  );
}
